import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import WhoItem from './WhoItem';
import CTAButton from './CTAButton';

const useStyles = makeStyles({
    whoSection: {
        paddingTop: "80px",
        paddingBottom: "80px",
        backgroundColor: "white",
    },
    whoHeader: {
        textAlign: "center",
        paddingBottom: '30px',
    },
    whoBody: {
    },
})

function WhoSection() {

    var classes = useStyles();

    return (
        <div className={classes.whoSection}>
            <div className="container">
                <div className={classes.whoHeader}>
                    <h1>Who is this workshop for?</h1>
                </div>
                <div className={classes.whoBody}>
                    <div className="row" style={{justifyContent: 'center'}}>
                        <div className="col-md-6">
                            <WhoItem image="/pitchbattle/images/icons/entrepreneur.png" heading="Budding Entrepreneur" body="Who is looking to learn skills that can help in their startup" />
                        </div>
                        <div className="col-md-6">
                            <WhoItem image="/pitchbattle/images/icons/student.png" heading="Students" body="Who is looking to kickstart their career" />
                        </div>
                        <div className="col-md-6">
                            <WhoItem image="/pitchbattle/images/icons/startup.png" heading="Startup Enthusiast" body="Who wants to be part of a growing community of some of the best minds in the industry" />
                        </div>
                        <div className="col-md-6">
                            <WhoItem image="/pitchbattle/images/icons/problem-solving.png" heading="Problem Solver" body="Who loves to solve real life problem and interact with new people" />
                        </div>
                        {/* <div className="col-md-6">
                            <WhoItem image="/pitchbattle/images/icons/internship.png" heading="Internship Wanderer" body="Who is looking to work with Startups" />
                        </div> */}
                    </div>
                </div>
                <CTAButton />
            </div>
        </div>
    )
}

export default WhoSection
